// 클라우드 사이트로 열었는지 + 로그인한 사람 — 설정 화면 등이 읽는다 (CloudGate 가 채운다).
import { useSyncExternalStore } from 'react';
import type { CloudMe } from './api';

let current: CloudMe | null = null;
const listeners = new Set<() => void>();

export function setCloudState(me: CloudMe | null): void {
  current = me;
  listeners.forEach((l) => l());
}

export const useCloud = (): CloudMe | null =>
  useSyncExternalStore((l) => {
    listeners.add(l);
    return () => listeners.delete(l);
  }, () => current);
